import { ApiAuthNetworkContextCompatibleResSchema } from "@bridge-applications/pb-types";
import type { z } from "zod";

export type AnalyticsContextResponse = z.infer<
    typeof ApiAuthNetworkContextCompatibleResSchema
>;
export const ANALYTICS_CONTEXT_PATH = "/api/auth/network-context?version=2";

/** Bounded per-launch orchestration; dependency injection keeps cancellation testable. */
export async function requestAnalyticsContext(input: {
    fetch: () => Promise<AnalyticsContextResponse>;
    wait: (milliseconds: number) => Promise<void>;
    isCurrent: () => boolean;
    apply: (response: AnalyticsContextResponse) => void;
}): Promise<void> {
    await input.wait(250);
    for (let attempt = 0; attempt < 2 && input.isCurrent(); attempt += 1) {
        const response = await input.fetch();
        if (!input.isCurrent()) return;
        input.apply(response);
        if (response.status !== "OK") return;
        const networkDelay =
            response.networkContext.state === "PENDING"
                ? response.networkContext.retryAfterMilliseconds
                : 0;
        const countryDelay =
            "countryContext" in response &&
            response.countryContext.state === "PENDING"
                ? response.countryContext.retryAfterMilliseconds
                : 0;
        const delay = Math.max(networkDelay, countryDelay);
        if (!delay || attempt === 1) return;
        await input.wait(delay);
    }
}
